import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from 'workOrderComponents/close/CustomStep';
import DeliveryProofPanel from "./DeliveryProofPanel";

const DeliveryProofCloseStep = (props) => {
  const {
    workOrderActions,
    orderId,
    index,
    orderCloseDetails,
    stepConfig,
    customerDetail
  } = props;

  const stepValidation = orderCloseDetails.getIn(['stepValidation']);
  const activeStep = orderCloseDetails.get('currentStep');

  const label = (
    <div style={{
      width: '100%'
    }}>
      <div>Skinny Install kit - Proof of Delivery</div>
    </div>
  );

  return ( <CustomStep
      onStepClick={workOrderActions.setCloseStep}
      label={label}
      stepConfig={stepConfig}
      stepConfigKey="deliveryProofStepConfig"
      index={index}
      activeStep={activeStep}
      orderId={orderId}
      stepValidation={stepValidation}
      stepKey="deliveryProof">
      <DeliveryProofPanel
        orderCloseDetails={orderCloseDetails}
        workOrderActions={workOrderActions}
        orderId={orderId}
        customerDetail={customerDetail}
      />
    </CustomStep>
  );
};

DeliveryProofCloseStep.propTypes = {
  workOrderActions: PropTypes.object,
  orderCloseDetails: PropTypes.object,
  customerDetail: PropTypes.object,
  orderId: PropTypes.string,
  index: PropTypes.number,
  stepConfig: PropTypes.object,
};

export default DeliveryProofCloseStep;



// WEBPACK FOOTER //
// ./src/components/delivery-proof/DeliveryProofCloseStep.js